import { useMemo } from 'react';
import { MoveTimeCriteriaType } from '~/types';

const extractIds = value => {
  if (Array.isArray(value)) {
    return value.map(v => v.id);
  }

  return [value.id];
};

export const useCriteriaToFilter = (criteria = []) => {
  return useMemo(() => {
    const filter = {};

    criteria.forEach(criterion => {
      if (
        !criterion.value ||
        (Array.isArray(criterion.value) && criterion.value.length === 0)
      ) {
        return;
      }

      switch (criterion.type) {
        case MoveTimeCriteriaType.User:
          filter.users = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.DateRange:
          filter.dateRange = criterion.value;
          break;
        case MoveTimeCriteriaType.Department:
          filter.departments = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.Location:
          filter.locations = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.EmployeeType:
          filter.employeeTypes = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.CostCenter:
          filter.costCenters = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.ServiceCenter:
          filter.serviceCenters = extractIds(criterion.value);
          break;
        case MoveTimeCriteriaType.Division:
          filter.divisions = extractIds(criterion.value);
          break;
        default:
          break;
      }
    });

    return filter;
  }, [criteria]);
};

export default useCriteriaToFilter;
